export default __webpack_public_path__ + "static/media/prospectiveStudent.78477f87.svg";